import { createSlice } from "@reduxjs/toolkit";

export const planogramFeedbackSlice = createSlice({
  name: "planogramFeedback",
  initialState: {
    loading: false,
    snackbarOpen: false,
    snackbarMessage: "",
    snackbarMessageSeverity: "info"
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSnackbarOpen(state, action) {
      state.snackbarOpen = action.payload;
    },
    setSnackbarMessage(state, action) {
      state.snackbarMessage = action.payload;
    },
    setSnackbarMessageSeverity(state, action) {
      state.snackbarMessageSeverity = action.payload;
    }
  }
})